import BackofficeMenu from '../menu/BackofficeMenu';
import { Outlet, useLocation, useNavigate } from 'react-router';
import Loading from 'pages/shared/loading/Loading';
import { useContext, useEffect, useState } from 'react';
import { NotificationContext } from 'shared/NotificationContext';
import { Administrator, NotificationType } from 'shared/topchef.types';
import backofficeApi from 'shared/topchef-api-backoffice';
import { useErrorBoundary } from 'react-error-boundary'
import Footer from 'pages/shared/footer/Footer'
import { BackofficeCountryProvider } from 'shared/BackofficeCountryContext';
import { useTranslation } from 'react-i18next';

const BackofficeHome = () => {

  const { t } = useTranslation();
  const [isReady, setReady] = useState<boolean>(false);
  const [getCurrentAdmin, setCurrentAdmin] = useState<Administrator | null>(null);
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const navigate = useNavigate();
  const location = useLocation();
  
  const { showBoundary } = useErrorBoundary();

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function getLoggedInAdminDetails() {

      try {
        const admin: Administrator = await backofficeApi.getLoggedIAdmin();
        setCurrentAdmin(admin);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadUserInfo', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        showBoundary(newError);
      } 
    }

    if (isReady === false) {
      getLoggedInAdminDetails();
      return;
    }

    if (location.pathname === '/backoffice') {
      navigate('/backoffice/dashboard');
      return;
    }

  }, [navigate, location.pathname, getCurrentAdmin, isReady, triggerNotification, showBoundary]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isReady) {
    return (
      <Loading />
    );
  }

  return (
    <BackofficeCountryProvider>
      <div className="d-flex backoffice" style={{height: "100vh"}}>
        <BackofficeMenu loggedInAdmin={getCurrentAdmin!}/>
        <>
          <Outlet />
          <Footer />
        </>
      </div>
    </BackofficeCountryProvider>
  );

}

export default BackofficeHome;
